import { Grid } from '@chakra-ui/react'
import SectionStack from 'components/common/SectionStack'
import { FC } from 'react'

const IfopOperation: FC<any> = ({ navigation, children }) => {
  return (
    <Grid templateColumns={{ base: 'none', lg: '1.5fr 1fr' }}>
      <SectionStack pl={{ '2xl': 0 }}>{children}</SectionStack>
      <SectionStack pr={{ '2xl': 0 }}>{navigation}</SectionStack>
    </Grid>
  )
}

export default IfopOperation
